import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavHistory } from "@/contexts/NavigationHistoryContext";

interface BackButtonProps {
  fallback?: string;
  label?: string;
  className?: string;
  /** Variant passed through to the underlying Button */
  variant?: "ghost" | "outline" | "default";
  size?: "sm" | "default" | "lg";
}

export function BackButton({
  fallback = "/annonser",
  label = "Tillbaka",
  className = "mb-6 text-muted-foreground",
  variant = "ghost",
  size = "sm",
}: BackButtonProps) {
  const { goBack } = useNavHistory();

  return (
    <Button variant={variant} size={size} className={className} onClick={() => goBack(fallback)}>
      <ArrowLeft className="mr-1 h-4 w-4" /> {label}
    </Button>
  );
}
